import { ViewProperties } from "../../../utils/ViewProperties";
export class GameSlingoParticleProperties extends ViewProperties {
    constructor() {
        super(...arguments);
        this.colours = [
            0xf6a9e9,
            0xffc7a0,
            0xa9e8ff,
            0xdfff9c,
            0xe3baff,
        ];
        this.slingoAmountToSpawnChanceMultiplier = [
            0.6,
            1,
            1.4,
            1.6
        ];
        this.glowProperties = {
            distance: 8,
            outerStrength: 3
        };
    }
    getEmitterProperties() {
        return {
            autoUpdate: true,
            frequency: 0.002,
            maxParticles: 1000,
            spawnChance: GameSlingoParticleProperties.BASE_SPAWN_CHANCE,
            pos: {
                x: 0,
                y: 0,
            },
            lifetime: {
                min: 0.5,
                max: 0.65
            },
            emitterLifetime: 1,
            addAtBack: true,
            behaviors: [
                {
                    type: "spawnShape",
                    config: {
                        type: "polygonalChain",
                        data: this.getSpawnZone(),
                    }
                },
                {
                    type: "textureRandom",
                    config: {
                        textures: [
                            "Game-ParticleStarOutline",
                            "Game-ParticleStarOutline",
                            "Game-ParticleStarOutline",
                            "Game-ParticleStarFill",
                        ]
                    }
                },
                {
                    type: "rotationStatic",
                    config: {
                        min: 0,
                        max: 360,
                    }
                },
                {
                    type: "moveAcceleration",
                    config: {
                        accel: {
                            x: 0,
                            y: 0,
                        },
                        minStart: 100,
                        maxStart: 130,
                        rotate: true,
                    }
                },
                {
                    type: "scale",
                    config: {
                        scale: {
                            list: [{ value: 0, time: 0 }, { value: 1, time: 0.2 }, { value: 0, time: 1 }],
                            isStepped: false
                        },
                        minMult: 0.1
                    }
                }
            ]
        };
    }
    static createSpawnZone(padding, width, height, midLineHeight) {
        return [
            [
                { x: padding.x, y: padding.y },
                { x: padding.x + width, y: padding.y },
                { x: padding.x + width, y: padding.y + height },
                { x: padding.x, y: padding.y + height },
                { x: padding.x, y: padding.y }
            ],
            //Include these lines below for the reel to also be separated
            [
                { x: padding.x, y: padding.y + midLineHeight },
                { x: padding.x + width, y: padding.y + midLineHeight }
            ]
        ];
    }
}
GameSlingoParticleProperties.BASE_SPAWN_CHANCE = 0.2;
//# sourceMappingURL=GameSlingoParticlesProperties.js.map